@if ((tableVm$ | async)) {
  @if (showTable && tableConfig) {
    <snelstart-ui-table [config]="tableConfig">

      <snelstart-ui-table-col columnType="string" name="label" width="400px">
        <snelstart-ui-table-col-header>
          {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }}
          @if ((incomeTaxEntity$ | async)?.aangifte?.partnerAangifte) {
            & {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }}
          }
        </snelstart-ui-table-col-header>

        <snelstart-ui-table-expanded-row>
          <ng-template let-entity>
            @for (subOnderdeel of entity?.subonderdelen ?? []; track subOnderdeel.value) {
              @if (subOnderdeel.visible) {
                <div>
                  <snelstart-ui-button
                    (click)="navigateToSubPage(subOnderdeel.pageMapping)"
                    class="ps-5"
                    icon="chevron-right"
                    type="link">
                    <div
                      [ngStyle]="subOnderdeel.pageMapping === activePage ? {'color': '#0073dd', 'font-weight': 'bold'} : {}">
                      {{ subOnderdeel.label }}
                    </div>
                  </snelstart-ui-button>
                </div>
              }
            }
          </ng-template>
        </snelstart-ui-table-expanded-row>
      </snelstart-ui-table-col>

      <snelstart-ui-table-col [showFilter]="false" [showSort]="false" columnType="currency" name="tekst"
                              width="200px">
        <snelstart-ui-table-col-header></snelstart-ui-table-col-header>

        <snelstart-ui-table-col-data>
          <ng-template let-record="record">
            <ng-container>
                @if (record.value === 200) {
                  <a>Belastbare winst:</a>
                }

            </ng-container>
            <ng-container>
                @if (record.value === 300) {
                  <a>Belastbare loon:</a>
                }
            </ng-container>
            <ng-container>

                @if (record.value === 400) {
                  <a>Overig inkomen:</a>
                }
            </ng-container>
            <ng-container>
                @if (record.value === 500) {
                  <a>Inkomsten eigen woning:</a>
                }
            </ng-container>
            <ng-container>
                @if (record.value === 600) {
                  <a>Aftrekbare premies:</a>
                }
            </ng-container>
            <ng-container>
                @if (record.value === 700) {
                  <a>Inkomen box 2:</a>
                }
            </ng-container>
            <ng-container>
                @if (record.value === 800) {
                  <a>Grondslag box 3:</a>
                }
            </ng-container>
            <ng-container>
                @if (record.value === 900) {
                  <a>Persoonsgebonden aftrek:</a>
                }
            </ng-container>
            <ng-container>
                @if (record.value === 1100) {
                  <a>Voorheffingen:</a>
                }
            </ng-container>

            @if (record.value === 1200) {
              <div style="font-weight: bold">
                @if ((aangifteBerekening$ | async)?.partnerBerekening === undefined) {
                  <div>
                    <a *ngIf="(sumAanslagenIbenZvw ? sumAanslagenIbenZvw : 0) < 0"
                    >Te ontvangen:</a>
                    <a *ngIf="(sumAanslagenIbenZvw ? sumAanslagenIbenZvw : 0) >= 0"
                    >Te betalen:</a>
                  </div>
                }
                @if ((aangifteBerekening$ | async)?.partnerBerekening !== undefined && (aangifteBerekening$ | async)?.partnerBerekening!.verschuldigdeInkomstenbelasting !== undefined) {
                  <div>
                    <a *ngIf="(sumAanslagenIbenZvw ? sumAanslagenIbenZvw : 0) < 0 &&
                            (sumAanslagenIbenZvwPartner ?? 0) < 0"
                    >Te ontvangen:</a>
                    <a *ngIf="(sumAanslagenIbenZvw ? sumAanslagenIbenZvw : 0) >= 0 &&
                            (sumAanslagenIbenZvwPartner ?? 0) >= 0"
                    >Te betalen:</a>
                    <a *ngIf="(sumAanslagenIbenZvw ? sumAanslagenIbenZvw : 0) < 0 &&
                            (sumAanslagenIbenZvwPartner ?? 0) >= 0"
                    >Te ontvangen resp. te betalen:</a>
                    <a *ngIf="(sumAanslagenIbenZvw ? sumAanslagenIbenZvw : 0) >= 0 &&
                            (sumAanslagenIbenZvwPartner ?? 0) < 0"
                    >Te betalen resp. te ontvangen:</a>
                  </div>
                }
              </div>
            }
          </ng-template>
        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>

      <snelstart-ui-table-col [showFilter]="false" [showSort]="false" columnType="currency" name="berekeningAangever"
                              width="200px">
        <snelstart-ui-table-col-header>
          <div style="font-size: 13px; color: #00200b ">
            {{ "Aangever" }}
          </div>
        </snelstart-ui-table-col-header>

        <snelstart-ui-table-col-data>
          <ng-template let-record="record">
            <ng-container>
              <a
                *ngIf="record.value === 200">{{ (aangifteBerekening$ | async)?.box1?.opbouwInkomen?.winstUitOnderneming?.toLocaleString() ?? '' }}</a>
            </ng-container>
            <ng-container>
              <a
                *ngIf="record.value === 300">{{ (aangifteBerekening$ | async)?.box1?.opbouwInkomen?.belastbaarloon?.toLocaleString() ?? '' }}</a>
            </ng-container>
            <ng-container>
              <a *ngIf="record.value === 400">{{ sumOverigInkomen > 0 ? sumOverigInkomen.toLocaleString() : '' }}</a>
            </ng-container>
            <ng-container>
              <a
                *ngIf="record.value === 500">{{ sumEigenWoningAangever !== 0 ? sumEigenWoningAangever.toLocaleString() : '' }}</a>
            </ng-container>
            <ng-container>
              <a
                *ngIf="record.value === 600">{{ sumPremiesInkomensvoorzieningen > 0 ? (sumPremiesInkomensvoorzieningen * -1).toLocaleString() : '' }}</a>
            </ng-container>
            <ng-container>
              <a *ngIf="record.value === 700">{{ sumBox2Aangever > 0 ? sumBox2Aangever.toLocaleString() : '' }}</a>
            </ng-container>
            <ng-container>
              <a *ngIf="record.value === 800">{{
                  (aangifteBerekening$ | async)?.box3?.opbouwInkomen?.grondslagSparenEnBeleggen !== undefined &&
                  (aangifteBerekening$ | async)?.box3?.opbouwInkomen?.grondslagNaVerdeling! > 0 ? (aangifteBerekening$ | async)?.box3?.opbouwInkomen?.grondslagNaVerdeling?.toLocaleString() : ''
                }}</a>
            </ng-container>
            <ng-container>
              <a *ngIf="record.value === 900">{{ sumPGAAangever > 0 ? (sumPGAAangever * -1).toLocaleString() : '' }}</a>
            </ng-container>
            <ng-container>
              <a
                *ngIf="record.value === 1100">{{ sumVoorheffingen != 0 ? (sumVoorheffingen * -1).toLocaleString() : '' }}</a>
            </ng-container>
            <ng-container>
              <a *ngIf="record.value === 1200"><b>{{ sumAanslagenIbenZvw.toLocaleString() || '' }}</b></a>
            </ng-container>
          </ng-template>

        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>

      <snelstart-ui-table-col [showFilter]="false" [showSort]="false" columnType="currency" name="partnerBerekening"
                              width="200px">

        <snelstart-ui-table-col-header>
          <div
            *ngIf="(incomeTaxEntity$ | async)?.aangifte?.gezamenlijkeAangifte !== undefined && (incomeTaxEntity$ | async)?.aangifte?.gezamenlijkeAangifte"
            style="font-size: 13px; color: #00200b ">
            {{ "Partner" }}
          </div>
          <div
            *ngIf="(incomeTaxEntity$ | async)?.aangifte?.gezamenlijkeAangifte === undefined || !(incomeTaxEntity$ | async)?.aangifte?.gezamenlijkeAangifte"
            style="font-size: 13px; color: #00200b ">
            {{ "" }}
          </div>
        </snelstart-ui-table-col-header>

        <snelstart-ui-table-col-data>
          <ng-template let-record="record">
            <ng-container>
              <a *ngIf="record.value === 200">
                {{ (aangifteBerekening$ | async)?.partnerBerekening?.box1?.opbouwInkomen?.winstUitOnderneming?.toLocaleString() ?? '' }}
              </a>
            </ng-container>
            <ng-container>
              <a
                *ngIf="record.value === 300 && (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte && (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.box1 && (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.box1?.belastbaarLoon && (aangifteBerekening$ | async)?.partnerBerekening?.box1?.opbouwInkomen?.belastbaarloon">
                {{ (aangifteBerekening$ | async)?.partnerBerekening?.box1?.opbouwInkomen?.belastbaarloon?.toLocaleString() }}
              </a>
            </ng-container>
            <ng-container>
              <a
                *ngIf="record.value === 400">{{ sumOverigInkomenPartner !== 0 ? sumOverigInkomenPartner.toLocaleString() : '' }}</a>
            </ng-container>
            <ng-container>
              <a
                *ngIf="record.value === 500">{{ sumEigenWoningPartner !== 0 ? sumEigenWoningPartner.toLocaleString() : '' }}</a>
            </ng-container>
            <ng-container>
              <a
                *ngIf="record.value === 600">{{ sumPremiesInkomensvoorzieningenPartner !== 0 ? (sumPremiesInkomensvoorzieningenPartner * -1).toLocaleString() : '' }}</a>
            </ng-container>
            <ng-container>
              <a *ngIf="record.value === 700">{{ sumBox2Partner > 0 ? sumBox2Partner.toLocaleString() : '' }}</a>
            </ng-container>
            <ng-container>
              <a *ngIf="record.value === 800">{{
                  (aangifteBerekening$ | async)?.box3?.opbouwInkomen?.grondslagSparenEnBeleggen !== undefined &&
                  (aangifteBerekening$ | async)?.partnerBerekening?.box3?.opbouwInkomen?.grondslagNaVerdeling! > 0 ? (aangifteBerekening$ | async)?.partnerBerekening?.box3?.opbouwInkomen?.grondslagNaVerdeling?.toLocaleString() : ''
                }}</a>
            </ng-container>
            <ng-container>
              <a *ngIf="record.value === 900">{{ sumPGAPartner > 0 ? (sumPGAPartner * -1).toLocaleString() : '' }}</a>
            </ng-container>
            <ng-container>
              <a
                *ngIf="record.value === 1100">{{ sumVoorheffingenPartner != 0 ? (sumVoorheffingenPartner * -1).toLocaleString() : '' }}</a>
            </ng-container>
            <ng-container>
              <div
                *ngIf="(incomeTaxEntity$ | async)?.aangifte?.gezamenlijkeAangifte !== undefined && (incomeTaxEntity$ | async)?.aangifte?.gezamenlijkeAangifte">
                <a *ngIf="record.value === 1200"><b>{{ sumAanslagenIbenZvwPartner.toLocaleString() || '' }}</b></a>
              </div>
            </ng-container>
          </ng-template>
        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>
    </snelstart-ui-table>
  }

  <snelstart-venture-fiscaal-domain-logic-service (created)="onAangifteCreated()"
                                                  [(dialogVisible)]="this.dialogVisible"
                                                  [title]="'Nieuwe aangifte aanmaken'">
  </snelstart-venture-fiscaal-domain-logic-service>
}
